module.exports = __webpack_public_path__ + "media/features/audio-hero/images/phones_tablet_de-dd7ad1ac64d685eb4fd7bdf63eb752f9.png";